module.exports = __webpack_public_path__ + "media/images/logos/app-logo-white-navy-bg-800px-56862183863ba67d54963f4bab5bdc71.png";